import { render, staticRenderFns } from "./FilteredContent.vue?vue&type=template&id=11c3fdb7&scoped=true&"
import script from "./FilteredContent.vue?vue&type=script&lang=ts&"
export * from "./FilteredContent.vue?vue&type=script&lang=ts&"
import style0 from "./FilteredContent.vue?vue&type=style&index=0&id=11c3fdb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3fdb7",
  null
  
)

export default component.exports